<template>
  <modal
    :header-text="$t('modal.addNewUser')"
    :button-text="$t('global.add')"
    :class="$style.modal"
    @action="addUser()"
    @close="$emit('close')"
  >
    <div :class="$style.inputContainer">
      <label :class="$style.label">{{ $t('modal.userName') }}</label>
      <input v-model="name.compName" type="text" :class="$style.input">
    </div>

    <div :class="$style.inputContainer">
      <label :class="$style.label">{{ $t('modal.userDisplayName') }}</label>
      <input v-model="name.displayName" type="text" :class="$style.input">
    </div>
  </modal>
</template>

<script>
import { addNewUser } from '@/api/methods/settings';
import Modal from '@/components/common/modal/settings-modal.vue';
import { openToast, TOAST_TYPE } from '@/utils/open-toast';

export default {
  components: { Modal },
  props: ['users'],
  data: () => ({
    name: { compName: '', displayName: '' },
  }),
  computed: {
    numberOfComputers() {
      return this.$store.getters['software/numberOfComputers'] || ' ';
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async addUser() {
      if (this.users.length < this.numberOfComputers) {
        if (!this.name.compName) {
          openToast(this.$t('toast.userNameIsNotFilled'), TOAST_TYPE.ERROR);
          return;
        }
        if (!this.name.displayName) this.name.displayName = this.name.compName;
        const result = await addNewUser(this.name.displayName, this.name.compName);

        if (result > 0) {
          openToast(this.$t('toast.userSuccessfullyAdded'), TOAST_TYPE.SUCCSESS);
          this.name.compName = '';
          this.name.displayName = '';
          this.$emit('update');
        } else if (result === 0) {
          openToast(this.$t('toast.userAlreadyExists'), TOAST_TYPE.ERROR);
        } else if (result === null) {
          openToast(this.$t('toast.maxComputersLimitReached'), TOAST_TYPE.ERROR);
        } else {
          openToast(this.$t('toast.unknownError'), TOAST_TYPE.ERROR);
        }
      } else {
        openToast(this.$t('toast.maxComputersLimitReached'), TOAST_TYPE.ERROR);
      }
    },
  },
};
</script>

<style lang="scss" module>
  .input {
    margin: 5px;
    width: 60%;
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-radius: 4px;
    height: 30px;
  }

  .inputContainer {
    font-size: 13px;
    margin: 5px;
    display: flex;
    align-items: baseline;
    justify-content: space-between;
  }

  .label {
    width: 40%;
  }
</style>
